import React, { useMemo, useState, useEffect } from 'react'
import BlogFilters from '../../components/Blog/BlogFilters'
import BlogList from '../../components/Blog/BlogList'
import BlogHero from '../../components/Blog/BlogHero'
import MoreToRead from '../../components/Blog/MoreToRead'
import { blogPosts, blogTopics } from '../../data/blogPosts.jsx'
import Footer from '../../components/landing/Footer'
import NewsletterCTA from '../../components/About/NewsletterCTA'
const Blog = () => {
  const [activeTopic, setActiveTopic] = useState(blogTopics[0])
  useEffect(()=>{ window.scrollTo(0,0); },[])

  const filtered = useMemo(() => {
    if (!activeTopic) return blogPosts
    return blogPosts.filter(p => p.topic === activeTopic)
  }, [activeTopic])

  return (
    <>
      <BlogHero />
      <section className="py-6">
        <div className="px-6 mx-auto max-w-6xl">
          <BlogFilters topics={blogTopics} active={activeTopic} onChange={setActiveTopic} />
        </div>
      </section>

      <section className="pb-16">
        <div className="px-6 mx-auto max-w-6xl">
          <BlogList posts={filtered} />
          <MoreToRead />
        </div>
      </section>
      <NewsletterCTA/>
      <Footer/>
      
    </>
  )
}

export default Blog